// Estado de CARGA del trío obligatorio (policies/ux-ui-design.md §5). El skeleton dibuja la forma
// de lo que viene, para que la pantalla no salte cuando llegue.
//
// El shimmer se apaga con `prefers-reduced-motion` — es la única animación infinita del repo y la
// que más importa para sensibilidad vestibular. El candado vive al FINAL de `index.css`, por orden
// de fuente; ver la nota larga de ese archivo.

export interface SkeletonProps {
  className?: string;
}

export function Skeleton({ className = 'h-4 w-full' }: SkeletonProps) {
  return <span aria-hidden="true" className={`skeleton block rounded-lg ${className}`} />;
}

export interface SkeletonListProps {
  rows?: number;
  /** Texto que se anuncia mientras carga: sin esto, un lector de pantalla no oye nada. */
  label?: string;
}

/** Placeholder de una lista (bandeja, casos, definiciones). */
export function SkeletonList({ rows = 4, label = 'Cargando…' }: SkeletonListProps) {
  return (
    <div role="status" aria-live="polite" aria-busy="true" className="flex flex-col gap-4">
      <span className="sr-only">{label}</span>
      {Array.from({ length: rows }, (_, index) => (
        <div
          key={index}
          className="rounded-3xl border border-white/20 bg-white/60 p-6 backdrop-blur-xl dark:border-zinc-800/50 dark:bg-zinc-900/60"
        >
          <Skeleton className="h-4 w-2/5" />
          <Skeleton className="mt-3 h-3 w-3/5" />
        </div>
      ))}
    </div>
  );
}
